import { render, staticRenderFns } from "./compulsory.vue?vue&type=template&id=e4f35d46"
import script from "./compulsory.vue?vue&type=script&lang=js"
export * from "./compulsory.vue?vue&type=script&lang=js"
import style0 from "./compulsory.vue?vue&type=style&index=0&id=e4f35d46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports